export const checkinmanual = {
    text1: "تسجيل الوصول اليدوي",
    text2: "أدخِل البيانات المطلوبة لتسجيل النزيل.",
    text3: "معلومات وحدة الإقامة",
    text4: "اختر وحدة الإقامة *",
    text5: "المعلومات الشخصية",
    text6: "الاسم الأول للنزيل *",
    text7: "اسم عائلة النزيل *",
    text8: "ذكر",
    text9: "أنثى",
    text10: "أفضّل عدم الإفصاح",
    text11: "آخر",
    text12: "اختر الجنس *",
    text13: "تاريخ الميلاد *",
    text14: "رقم الهاتف *",
    text15: "معلومات الإقامة",
    text16: "معلومات الإقامة إلزامية لمتابعة تسجيل الوصول. يرجى تعبئة جميع الحقول.",
    text17: "من - إلى",
    text18: "حتى أي تاريخ سيقيم النزيل؟",
    text19: "البريد الإلكتروني للنزيل *",
    text20: "اختر نوع الوثيقة.",
    text21: "بطاقة الهوية",
    text22: "جواز السفر",
    text23: "نوع الوثيقة",
    text24: "رقم الوثيقة",
    text25: "أدخِل رقم الوثيقة",
    text26: "انتهاء صلاحية الوثيقة",
    text27: "انتهاء صلاحية الوثيقة",
    text28: "متابعة",
    text29: "تسجيل الوصول اليدوي",
    text30: "أدخِل البيانات المطلوبة لتسجيل النزيل.",
    text31: "توقيع تسجيل الوصول",
    text32: "وقّع داخل المربع الرمادي الظاهر على الشاشة",
    text33: "حفظ تسجيل الوصول",
    text34: "اكتملت عملية تسجيل الوصول بنجاح.",
    text35: "عليك اختيار وحدة إقامة لإسناد تسجيل الوصول إليها",
    text36: "حقل الاسم مطلوب",
    text37: "حقل اسم العائلة مطلوب",
    text38: "حقل الجنس مطلوب",
    text39: "حقل تاريخ الميلاد مطلوب",
    text40: "حقل الهاتف مطلوب",
    text41: "حقل تاريخ الإقامة مطلوب",
    text42: "حقل البريد الإلكتروني مطلوب",
    text43: "حقل الدولة مطلوب",
    text44: "حقل نوع الوثيقة مطلوب",
    text45: "حقل رقم الوثيقة مطلوب",
    text46: "عليك قبول الشروط والأحكام.",
    text47: "جارٍ إرسال بيانات تسجيل الوصول، يرجى الانتظار...",
    text48: "جارٍ التحميل...",
    text49: "أكمل تسجيل الوصول بنجاح.",
    text50: "اضغط هنا لرؤية جميع خدماتنا المتاحة في الفندق",
    text51: "أدخِل الاسم الأول",
    text52: "أدخِل اسم العائلة",
    text53: "الدولة",
    text54: "خطأ",
    text55: "أدخِل عنوان البريد الإلكتروني",

    // Corrections
    p1: "تاريخ تسجيل الوصول",
    p2: "تاريخ تسجيل المغادرة",
    p3: "تاريخ إصدار الوثيقة",
    p4: "",
    p5: "",
    p6: "",
    p7: "",
    p8: "",
};
